import { render, staticRenderFns } from "./EditHoldTicketPage.vue?vue&type=template&id=418486fd&scoped=true&"
import script from "./EditHoldTicketPage.vue?vue&type=script&lang=ts&"
export * from "./EditHoldTicketPage.vue?vue&type=script&lang=ts&"
import style0 from "./EditHoldTicketPage.vue?vue&type=style&index=0&id=418486fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418486fd",
  null
  
)

export default component.exports